var path = 'public/app/plugins/panel/graph/tab_thresholds.html';
var html = "<graph-threshold-form panel-ctrl=ctrl></graph-threshold-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;